function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import Geohash from 'latlon-geohash';
import { isA } from '../../utils/testing';
import { SimpleSearchQueryField } from '../simple-search-query-field';
var pointToHash = point => Geohash.encode(point.lat, point.lon, 12);
var hashToPoint = hash => Geohash.decode(hash);
var parseBounds = hashList => {
  if (!hashList || typeof hashList !== 'string') {
    return undefined;
  }
  var _hashList$split = hashList.split(','),
    _hashList$split2 = _slicedToArray(_hashList$split, 2),
    from = _hashList$split2[0],
    to = _hashList$split2[1];
  return {
    from: hashToPoint(from),
    to: hashToPoint(to)
  };
};
var boundsIsValid = bounds => !!(bounds !== null && bounds !== void 0 && bounds.from) && !!(bounds !== null && bounds !== void 0 && bounds.to);
export class Bounds extends SimpleSearchQueryField {
  constructor(searchOptions, inputValue) {
    var valueObject = Bounds.isInstance(inputValue) ? inputValue.value : inputValue;
    super(searchOptions, boundsIsValid(valueObject) ? {
      from: valueObject.from,
      to: valueObject.to
    } : null);
    _defineProperty(this, "urlSlug", Bounds.urlSlug);
  }
  isBounds() {
    return true;
  }
  isDefault() {
    return this.isEmpty();
  }
  isEmpty() {
    return this.value == null || this.value.from == null && this.value.to == null;
  }
  get from() {
    var _this$value;
    return (_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.from;
  }
  get to() {
    var _this$value2;
    return (_this$value2 = this.value) === null || _this$value2 === void 0 ? void 0 : _this$value2.to;
  }
  getUrlParameterValue() {
    return this.value ? "".concat(pointToHash(this.value.from), ",").concat(pointToHash(this.value.to)) : null;
  }
  static isInstance(obj) {
    return isA(obj, 'Bounds');
  }
  static fromUrlParameters(searchOptions, q) {
    return new Bounds(searchOptions, parseBounds(q[Bounds.urlSlug]));
  }
}
_defineProperty(Bounds, "urlSlug", 'bounds');